import PropTypes from "prop-types";
import React, { useState } from "react";
import CustomAccordion from "../../../../app/common-components/Accordion.jsx";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";

const DrillDownAccordion = (props) => {
  const [state, setState] = useState({
    modalBodyPopup: props.modalBody,
  });
  const modalBodypopupModal = () => {
    return (
      <>
        <CustomAccordion
          pluginId={props.pluginId}
          cvssScore={props.cvssScore}
          version={props.version}
          sections={props.data}
          sbompage={props.sbompage}
          isDI={props.isDI}
          isSbom={props.isSbom}
        />
      </>
    );
  };
  const handleClosePopup = () => {
    setState({
      ...state,
      modalBodyPopup: false,
    });
    props.accordionFalse();
  };
  return (
    <>
      {props.enableSpinner ? (
        <div style={{ margin: "15% 0" }}>
          <Spinners />
        </div>
      ) : (
        <CustomModal
          modalOpen={state.modalBodyPopup}
          modalBody={modalBodypopupModal}
          modalHide={handleClosePopup}
          closeBtn={true}
          closeBtnFuc={handleClosePopup}
          size={"lg"}
        />
      )}
    </>
  );
};
export default DrillDownAccordion;
DrillDownAccordion.propTypes = {
  modalBody: PropTypes.arrayOf(PropTypes.string),
  pluginId: PropTypes.arrayOf(PropTypes.string),
  cvssScore: PropTypes.arrayOf(PropTypes.string),
  version: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(PropTypes.string),
  accordionFalse: PropTypes.arrayOf(PropTypes.string),
  enableSpinner: PropTypes.arrayOf(PropTypes.string),
};
